import React from 'react';
import { connect } from 'react-redux';
import { Counter } from '../../../components';
import { changeNumberOfPeople } from '../../../redux/actions/trekPaymentReviewActions';

const mapDispatchToProps = dispatch => ({
  onChangePax: num => dispatch(changeNumberOfPeople(num)),
});

const mapActionToProps = ({ trekPayment: { noOfPeople } }) => ({
  pax: noOfPeople,
});

type Props = {
  pax: number,
  onChangePax: (pax: number) => void,
};

const ConnectedCounter = ({ pax, onChangePax }: Props) => (
  <Counter title="No of People" onChange={onChangePax} value={pax} />
);

export default connect(
  mapActionToProps,
  mapDispatchToProps
)(ConnectedCounter);



// WEBPACK FOOTER //
// ./src/screens/Trek/Common/ConnectedCounter.js